/**
 * LessonLink - 認証モジュール
 */
import {
  signIn,
  signOut,
  getCurrentUser,
  confirmSignIn,
  updatePassword,
} from 'aws-amplify/auth';
import { showMessage, clearMessage, showPage, setNavVisible, pages } from './utils';

let pendingUser: any = null;

export function initAuth(onLoginSuccess: () => void, onLogout?: () => void) {
  const loginForm = document.getElementById('login-form') as HTMLFormElement;
  const newPasswordForm = document.getElementById('new-password-form') as HTMLFormElement;
  const changePasswordForm = document.getElementById('change-password-form') as HTMLFormElement;
  const logoutBtn = document.getElementById('logout-btn') as HTMLButtonElement;

  // ログイン
  loginForm.addEventListener('submit', async (e) => {
    e.preventDefault();
    clearMessage();
    const email = (document.getElementById('login-email') as HTMLInputElement).value;
    const password = (document.getElementById('login-password') as HTMLInputElement).value;

    try {
      const result = await signIn({ username: email, password });
      if (result.nextStep.signInStep === 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED') {
        pendingUser = result;
        showPage(pages.pageNewPassword);
        return;
      }
      if (result.isSignedIn) {
        setNavVisible(true);
        showPage(pages.pageSchedule);
        showMessage('ログインしました', 'success');
        onLoginSuccess();
      }
    } catch (error: any) {
      console.error('Login error:', error);
      if (error.name === 'UserNotFoundException' || error.name === 'NotAuthorizedException') {
        showMessage('メールアドレスまたはパスワードが正しくありません');
      } else {
        showMessage('ログインに失敗しました。しばらくしてからお試しください。');
      }
    }
  });

  // 初回パスワード変更
  newPasswordForm.addEventListener('submit', async (e) => {
    e.preventDefault();
    clearMessage();
    const newPassword = (document.getElementById('new-password') as HTMLInputElement).value;
    const confirmPassword = (document.getElementById('confirm-password') as HTMLInputElement).value;

    if (newPassword !== confirmPassword) {
      showMessage('パスワードが一致しません');
      return;
    }
    if (!/\d/.test(newPassword)) {
      showMessage('パスワードには数字を含めてください');
      return;
    }

    try {
      const result = await confirmSignIn({ challengeResponse: newPassword });
      if (result.isSignedIn) {
        setNavVisible(true);
        showPage(pages.pageSchedule);
        showMessage('パスワードを設定しました', 'success');
        onLoginSuccess();
      }
    } catch (error: any) {
      console.error('New password error:', error);
      let errorMsg = 'パスワードの設定に失敗しました。';
      if (error.name === 'InvalidPasswordException') {
        errorMsg = 'パスワードは8文字以上、大文字・小文字・数字・記号（!@#$%^&*など）を含めてください。';
      } else if (error.message) {
        errorMsg += ` (${error.message})`;
      }
      showMessage(errorMsg);
    }
  });

  // パスワード変更（設定画面）
  changePasswordForm.addEventListener('submit', async (e) => {
    e.preventDefault();
    clearMessage();
    const currentPassword = (document.getElementById('current-password') as HTMLInputElement).value;
    const newPassword = (document.getElementById('settings-new-password') as HTMLInputElement).value;
    const confirmPassword = (document.getElementById('settings-confirm-password') as HTMLInputElement).value;

    if (newPassword !== confirmPassword) {
      showMessage('新しいパスワードが一致しません');
      return;
    }
    if (!/\d/.test(newPassword)) {
      showMessage('パスワードには数字を含めてください');
      return;
    }

    try {
      await updatePassword({ oldPassword: currentPassword, newPassword });
      showMessage('パスワードを変更しました', 'success');
      changePasswordForm.reset();
    } catch (error: any) {
      console.error('Change password error:', error);
      if (error.name === 'NotAuthorizedException') {
        showMessage('現在のパスワードが正しくありません');
      } else {
        showMessage('パスワードの変更に失敗しました');
      }
    }
  });

  // ログアウト
  logoutBtn.addEventListener('click', async () => {
    try {
      await signOut();
      setNavVisible(false);
      showPage(pages.pageLogin);
      showMessage('ログアウトしました', 'success');
      if (onLogout) onLogout();
    } catch (error) {
      console.error('Logout error:', error);
      showMessage('ログアウトに失敗しました');
    }
  });
}

export async function checkAuthState(onLoginSuccess: () => void) {
  try {
    await getCurrentUser();
    setNavVisible(true);
    showPage(pages.pageSchedule);
    onLoginSuccess();
  } catch {
    setNavVisible(false);
    showPage(pages.pageLogin);
  }
}
